import React from 'react'
import { Spinner, ISpinnerProps } from '@blueprintjs/core'

export default function (props: ISpinnerProps) {
  return <Spinner {...props} className="spinner" />
}
